import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, of, switchMap } from 'rxjs';
import { DealerFeature, TrackingFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from '../contact';

@Injectable()
export class ContactEffects {
    actions$ = inject(Actions);
    api = inject(DealerApiService);
    store = inject(Store);

    submitContactForm1$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitContactForm),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([action, slug]) => {
                return from(this.api.postContactForm(action.dealerSlug ?? slug, action.payload)).pipe(
                    switchMap(() => {
                        return [
                            actions.submitContactFormResponse({ success: true }),
                            TrackingFeature.actions.eventTrackingPush({
                                dataLayer: {
                                    event: 'contact_complete_dealer',
                                    contact: {
                                        topic: action.payload.topic ?? '',
                                    },
                                    dealer: {
                                        name: action.dealerName ?? '',
                                        code: action.dealerId ?? '',
                                    },
                                    user: {
                                        contact: {
                                            email: action.payload.email ?? '',
                                        },
                                    },
                                },
                            }),
                        ];
                    }),
                    catchError(() => {
                        return of(actions.submitContactFormResponse({ success: false }));
                    }),
                );
            }),
        );
    });
}
